var _rect, _rect2, _rect3, _line, _line2, _line3, _line4, _line5, _line6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresentation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 256,
    width: 256
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    height: 136,
    opacity: 0.2,
    rx: 8,
    width: 192,
    x: 32,
    y: 48
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 136,
    rx: 8,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16,
    width: 192,
    x: 32,
    y: 48
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16,
    x1: 160,
    x2: 192,
    y1: 184,
    y2: 224
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16,
    x1: 96,
    x2: 64,
    y1: 184,
    y2: 224
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16,
    x1: 96,
    x2: 96,
    y1: 120,
    y2: 144
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16,
    x1: 128,
    x2: 128,
    y1: 104,
    y2: 144
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16,
    x1: 160,
    x2: 160,
    y1: 88,
    y2: 144
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16,
    x1: 128,
    x2: 128,
    y1: 48,
    y2: 24
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentation);
export default __webpack_public_path__ + "static/media/presentation.9aa09e4390d4c1648845597c03263455.svg";
export { ForwardRef as ReactComponent };